import React from 'react';
import { useParams } from 'react-router-dom';
import IngresoCasoForm from '../components/IngresoCasoForm';

const IngresoCasoPage = () => {
  const { protocoloGeneral } = useParams();
  const isEditMode = Boolean(protocoloGeneral);

  return (
    <div className="container page-shell">
      <div className="page-header">
        <div>
          <span className="section-kicker">{isEditMode ? 'Edición' : 'Registro'}</span>
          <h2 className="page-title">{isEditMode ? 'Editar caso clínico' : 'Nuevo caso clínico'}</h2>
          <p className="page-subtitle">
            {isEditMode
              ? 'Actualiza la información del caso y completa los datos pendientes cuando lo necesites.'
              : 'Completa la información principal del caso para continuar con la carga de muestras y el cierre final.'}
          </p>
        </div>
        <img src="/logo-inta.png" alt="Logo INTA" className="page-header-logo" />
      </div>
      <IngresoCasoForm caseId={protocoloGeneral} />
    </div>
  );
};

export default IngresoCasoPage;
